const fieldId = function (lbl) {
  if (lbl) {
    const fieldIds = [
      { label: 'screeningmedicine', fieldId: 1293111 },
      { label: 'screeningvegan', fieldId: 8963171 },
      { label: 'screeningdiet', fieldId: 1293109 },
      { label: 'screeningegg', fieldId: 1293536 },
      { label: 'screeningcol', fieldId: 1293920 },
      { label: 'screeningfacility', fieldId: 1285837 },
      { label: 'screeningdiagnosis', fieldId: 1722201 },
      { label: 'screeninggentest', fieldId: 1722955 },
      { label: 'screeningmutation', fieldId: 1723082 },
      { label: 'screeningsmoking', fieldId: 10112900 },
      { label: 'screeninghypertension', fieldId: 10112959 },
      { label: 'screeningdiabetestype1', fieldId: 10112960 },
      { label: 'screeningdiabetestype2', fieldId: 10112961 },
      { label: 'screeningarteriosclerosis', fieldId: 10113022 },
      { label: 'screeningstroke', fieldId: 10113032 },
      { label: 'screeningpeephole', fieldId: 10113155 },
      { label: 'consentjournals', fieldId: 10113375 }
    ]
    const fieldIdByLabel = fieldIds.find(f => {
      return f.label === lbl
    })
    return fieldIdByLabel.fieldId
  }
}

export default fieldId



// WEBPACK FOOTER //
// ./src/plugins/fieldId.js